import React from 'react';
import NarrativeChapter from './NarrativeChapter';

const COMPARISON_ROWS = Object.freeze([
  {
    feature: 'Discovery',
    datingApp: 'Infinite, gamified swipe deck',
    milan: 'Curated 4-slot window',
  },
  {
    feature: 'Compatibility',
    datingApp: 'Photo-first stack sorted by popularity and proximity',
    milan: 'Built on reflections and taste weights',
  },
  {
    feature: 'Language',
    datingApp: 'Shows you profiles where you don’t share a common language',
    milan: 'You only see people you share a common language with',
  },
  {
    feature: 'Chapters',
    datingApp: 'Generic profile layout with no space for single parents or people restarting',
    milan: 'A chapter in life respecting your past and present',
  },
  {
    feature: 'Taste',
    datingApp: 'Generic hobby checklists and interest tags',
    milan: 'Multi-dimensional weights that adapt to what you value',
  },
  {
    feature: 'Focus',
    datingApp: 'Juggling parallel chats with dozens of matches',
    milan: 'Committing to one active match at a time to build depth',
  },
]);

/**
 * Renders a compact side-by-side comparison table contrasting dating app mechanics
 * with Milan's relationship principles as a guided narrative chapter.
 *
 * @param {object} props - Component properties.
 * @param {number} [props.index=9] - Zero-based guided-scroll chapter index.
 * @returns {React.ReactElement} A compact, responsive comparison matrix chapter.
 */
export default function ComparisonMatrix({ index = 9 }) {
  return (
    <NarrativeChapter
      index={index}
      id="comparison"
      tone="dark"
      title="How Milan differs from dating apps"
    >
      <div className="comparison-matrix-wrapper">
        <table className="comparison-matrix">
          <thead>
            <tr>
              <th scope="col">Principle</th>
              <th scope="col">Dating Apps</th>
              <th scope="col" className="milan-col-header">Milan</th>
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map((row) => (
              <tr key={row.feature}>
                <td className="feature-cell">{row.feature}</td>
                <td className="swipe-cell">
                  {row.datingApp}
                </td>
                <td className="milan-cell">
                  <strong>{row.milan}</strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </NarrativeChapter>
  );
}
